module.exports = __webpack_public_path__ + "img/strike-purple.a59d58d6.svg";